import React from 'react';
import { Testimonial } from '@bookstore/shared';
import { Star, User, Quote } from 'lucide-react';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow h-full flex flex-col">
      {/* Quote Icon */}
      <Quote className="w-8 h-8 text-primary-200 mb-4" />

      {/* Rating */}
      <div className="flex items-center gap-1 mb-3">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`w-5 h-5 ${
              i < testimonial.rating
                ? 'text-primary-400 fill-primary-400'
                : 'text-gray-300'
            }`}
          />
        ))}
      </div>

      {/* Comment */}
      <p className="text-primary-900 mb-4 leading-relaxed flex-grow overflow-y-auto">{testimonial.comment}</p>

      {/* User Info */}
      <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
        {testimonial.userImage ? (
          <img
            src={testimonial.userImage}
            alt={testimonial.userName}
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 bg-primary-light rounded-full flex items-center justify-center">
            <User className="w-6 h-6 text-primary" />
          </div>
        )}
        <div>
          <p className="font-semibold text-primary-800">{testimonial.userName}</p>
          <p className="text-sm text-gray-500">{testimonial?.userTitle || 'Verified Customer'}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;